(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("UYouData", [], factory);
	else if(typeof exports === 'object')
		exports["UYouData"] = factory();
	else
		root["UYouData"] = factory();
})(window, function() {
return 